import React from 'react';
import './TotalSummary.css';
import { useHistory } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TotalSummary = ({ cartItems, quantities, onCompleteSelection, reverseCategoryMap ,session, name, memo, handleMemoChange, couponCode, handleCouponCodeChange, applyCoupon, coupon, setCoupon, setCouponCode, totalItems}) => {
    const history = useHistory();
    // console.log(session)
    // 카테고리별 총합 계산
    const summary = cartItems.reduce((acc, item) => {
        const { category, price, id } = item;
        const quantity = quantities[id];
        const numericPrice = parseFloat(price.replace(/,/g, '')); // 쉼표 제거 후 숫자로 변환
        const mappedCategory = reverseCategoryMap[category] || '기타';

        if (!acc[mappedCategory]) {
            acc[mappedCategory] = { items: [], total: 0 };
        }
        acc[mappedCategory].items.push(item);
        acc[mappedCategory].total += numericPrice * quantity;
        return acc;
    }, {});


    // 전체 총합 계산
    // const totalQuantity = Object.values(summary).reduce((acc, { quantity }) => acc + quantity, 0);
    const totalPrice = Object.values(summary).reduce((acc, { total }) => acc + total, 0);

    let finalPrice = totalPrice;
    let discountAmount = 0;

    if (coupon) {
        if(coupon.type === 'PERCENTAGE_DISCOUNT') {
            finalPrice = totalPrice * (1-coupon.discountValue/100);
            discountAmount = totalPrice-finalPrice;
        } else if (coupon.type === 'FIXED_AMOUNT_DISCOUNT') {
            finalPrice = totalPrice-coupon.discountValue;
            discountAmount = totalPrice-finalPrice;
        }
    }
    // console.log(finalPrice);
    const formattedTotalPrice = totalPrice.toLocaleString();
    const formattedFinalPrice = finalPrice.toLocaleString();
    const formattedDiscountAmount = discountAmount.toLocaleString();


    const handleBackToShopping = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const name = urlParams.get('name');
        const session = urlParams.get('session');


        const checkSession = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/cart/auth/check?session=${session}&name=${name}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                // console.log(response);
                if (response.ok) {
                    const result = await response.json();
                    // console.log(result);
                    if (result) {
                        history.push(`/?session=${session}&name=${name}`);

                    } else {
                        history.push('/denied');
                    }
                } else {
                    history.push('/denied');
                }
            } catch (error) {
                console.error('Error checking session:', error);
                history.push('/denied');
            }
        };

        checkSession();
    };

    const handleRemoveCoupon = () => {
        setCoupon(null);
        setCouponCode('');
    }

    return (
        <div className='total-summary-container'>
            <div className='summary-details'>
                {Object.entries(summary).map(([category, { items, total }]) => (
                    <div key={category} className='summary-item'>
                        <span className='sum-category'>{category} {items.length} 종</span>
                        <span className='sum-price'>{total.toLocaleString()}원</span>
                    </div>
                ))}
                <div className='divider'></div>
                <div className='summary-total'>
                    <span className='total-num'>총 {totalItems} 종</span>
                    <span className='total-price'>{formattedTotalPrice}원</span>
              
                </div>
                {coupon && (
                    <div className='summary-coupon'>
                        <span className='discount-label'>쿠폰 적용</span>
                        <button className='remove-coupon-button' onClick={handleRemoveCoupon}>
                            <img src='/removeCoupon.png' alt='remove-coupon' className='remove-coupon-image'/>
                        </button>
                        <span className='discount-amount'>- {formattedDiscountAmount}원</span>
                    </div>
                )}
                {coupon && (
                    <div className='summary-final'>
                        <span className='final-num'>최종 가격</span>
                        <span className='final-price'>{formattedFinalPrice}원</span>
                    </div>
                    )}   
            </div>
            <div className='coupon-area'>
                <span className='coupon-label'>쿠폰 적용</span>
                <input 
                    type='text' 
                    placeholder='쿠폰코드를 입력해주세요' 
                    className='write-coupon'
                    value={couponCode}
                    onChange={handleCouponCodeChange}
                />
                <button 
                    className={`apply-coupon-button ${couponCode ? 'enabled' : 'disabled'}`}
                    onClick={applyCoupon}
                    disabled={!couponCode}
                > 쿠폰 적용하기</button>
            </div>
            <div className='memo-area'>
                <span className='memo-label'>요청사항</span>
                <textarea 
                    type='text' 
                    placeholder='추가로 전달하실 내용이 있다면 입력해주세요' 
                    className='write-memo'
                    value={memo}
                    onChange={handleMemoChange}/>
            </div>
            <button className='submit-button' 
                    onClick={onCompleteSelection}
                    disabled={cartItems.length === 0}>
                    클리니어스낵에 전달하기
            </button>
            <button className='back-button' onClick={handleBackToShopping}>
                <img src="/addMore.png" alt="Cart" className='button-image' />
                더 담으러가기
            </button>
        </div>
    );
};

export default TotalSummary;
